import style from "./index.module.scss";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Analytics } from "../../../services";
import BasicAnalytics from "../components/BasicAnalytics";
import OrderCountByPeriod from "../components/OrderCountByPeriod";
import TopRoutes from "../components/TopDirections";
import SLAComplianceByExpeditor from "../components/SLAComplianceByExpeditor";
import OrderCompletionPieChart from "../components/OrderCompletionPieChart";
import ExpeditorActivityChart from "../components/ExpeditorActivityChart";
import TopDirectionsMobile from "../components/TopDirectionsMobile";
import { useScreenSize } from "../../../hooks/useScreenSize";
import AnalyticsByTurnover from "../components/AnalyticsByTurnover";
import AnalyticsByClientOrders from "../components/AnalyticsByClientOrders";
import AnalyticsByClientPublicOrders from "../components/AnalyticsByClientPublicOrders";
import TopDirectionsTable from "../components/TopDirectionsTable";

const AnalyticsAviation = ({ user }) => {
  const { t } = useTranslation();
  const { isMobileView } = useScreenSize();

  const [baseMetricDateStart, setBaseMetricDateStart] = useState(moment().subtract(30, "days").toDate());
  const [baseMetricDateEnd, setBaseMetricDateEnd] = useState(new Date());
  const [currency, setCurrency] = useState("");

  const [baseMetric, setBaseMetric] = useState();
  const [orderCountByPeriod, setOrderCountByPeriod] = useState([]);
  const [topAirRoutes, setTopAirRoutes] = useState([]);
  const [SLACompliance, setSLACompliance] = useState([]);
  const [SLAComplianceExpeditor, setSLAComplianceExpeditor] = useState([]);
  const [expeditorActivity, setExpeditorActivity] = useState([]);
  const [turnover, setTurnover] = useState([]);
  const [completedOrders, setCompletedOrders] = useState([]);
  const [publicOrders, setPublicOrders] = useState([]);
  const [top10DirectionsTable, setTop10DirectionsTable] = useState();

  const startDate = useMemo(() => moment(baseMetricDateStart).format("YYYY-MM-DD"), [baseMetricDateStart]);
  const endDate = useMemo(() => moment(baseMetricDateEnd).format("YYYY-MM-DD"), [baseMetricDateEnd]);

  const fetchAnalyticsData = async (apiFunc, setter) => {
    try {
      const currencyParam = currency === "all" || currency === "" ? "" : currency;
      const response = await apiFunc(startDate, endDate, currencyParam);
      setter(response.data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchAnalyticsData(Analytics.getAirAverageOrderIndicators, setBaseMetric);
    fetchAnalyticsData(Analytics.getTopAirRoutes, setTopAirRoutes);
    fetchAnalyticsData(Analytics.getAirExpeditorActivity, setExpeditorActivity);
    fetchAnalyticsData(Analytics.getAirTurnover, setTurnover);
    fetchAnalyticsData(Analytics.getAirClientCreatedCompletedOrders, setCompletedOrders);
    fetchAnalyticsData(Analytics.getAirClientCreatedPublicOrders, setPublicOrders);
    fetchAnalyticsData(Analytics.getAirOrderCountByPeriod, setOrderCountByPeriod);
    fetchAnalyticsData(Analytics.getTop10AirRoutes, setTop10DirectionsTable)

    if (user.type === "Client") {
      fetchAnalyticsData(Analytics.getAirSLAComplianceClient, setSLACompliance);
    } else if (user.type === "Expeditor") {
      fetchAnalyticsData(Analytics.getAirSLAComplianceExpeditor, setSLAComplianceExpeditor);
    }
  }, [baseMetricDateStart, baseMetricDateEnd, currency]);

  return (
    <>
      <div className={style.wrapperAnalytics}>
        <BasicAnalytics
          item={baseMetric}
          startDate={baseMetricDateStart}
          setStartDate={setBaseMetricDateStart}
          endDate={baseMetricDateEnd}
          setEndtDate={setBaseMetricDateEnd}
          currency={currency} 
          setCurrency={setCurrency} 
        />

        <div className={style.metric}>
          <AnalyticsByTurnover item={turnover} currency={currency} />
          <AnalyticsByClientOrders item={completedOrders} />
        </div>
        <div className={style.metric}>
          <AnalyticsByClientPublicOrders item={publicOrders} />
        </div>

        {user.type === "Expeditor" ? (
          <>
            <div className={style.metric}>
              {isMobileView ? <TopDirectionsMobile item={topAirRoutes} /> : <TopRoutes item={topAirRoutes} />}
            </div>

            <div className={style.metric}>
              <OrderCompletionPieChart item={SLAComplianceExpeditor} />
              <OrderCountByPeriod item={orderCountByPeriod} />
            </div>
          </>
        ) : (
          <>
            <div className={style.metric}>
              <OrderCountByPeriod item={orderCountByPeriod} />
              {isMobileView ? <TopDirectionsMobile item={topAirRoutes} /> : <TopRoutes item={topAirRoutes} />}
            </div>
          </>
        )}


        <div className={style.metric}>
          {user.type === "Client" && (
            <>
              <SLAComplianceByExpeditor item={SLACompliance} />
              <ExpeditorActivityChart item={expeditorActivity} />
            </>
          )}
        </div>

        <TopDirectionsTable 
          top10DirectionsTable={top10DirectionsTable}
          currency={currency}  
        />
      </div>
    </>
  );
};

export default AnalyticsAviation;
